import AsyncStorage from "@react-native-async-storage/async-storage";
const asyncStorageStorage = () => {
    const read = async (key) => {
        const value = await AsyncStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    };
    const list = async () => {
        const value = await AsyncStorage.getAllKeys();
        return value;
    };
    const write = async (key, value) => AsyncStorage.setItem(key, JSON.stringify(value));
    const remove = async (key) => AsyncStorage.removeItem(key);
    const clear = async () => AsyncStorage.clear();
    return { read, list, write, remove, clear };
};
export { asyncStorageStorage };
